import { render, staticRenderFns } from "./sPoi.vue?vue&type=template&id=8acf8854&scoped=true&"
import script from "./sPoi.vue?vue&type=script&lang=js&"
export * from "./sPoi.vue?vue&type=script&lang=js&"
import style0 from "./sPoi.vue?vue&type=style&index=0&id=8acf8854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acf8854",
  null
  
)

export default component.exports